import { render, staticRenderFns } from "./MappingAttributesCompoment.vue?vue&type=template&id=076ee686"
import script from "./MappingAttributesCompoment.vue?vue&type=script&lang=js"
export * from "./MappingAttributesCompoment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports